const rules = [
    {
        field: 'mlsProviderId',
        method: 'isEmpty',
        validWhen: false,
        message: 'MLS Provider is required.'
    },
    {
        field: 'startDate',
        method: 'isEmpty',
        validWhen: false,
        message: 'Start Date is required.'
    },
    {
        field: 'endDate',
        method: 'isEmpty',
        validWhen: false,
        message: 'End Date is required.'
    },
];

export default rules;
